<div class="b-window">
  <div class="b-content flex-xy-align">
    <div class="empty-content-container">
      <p class="mb-4">
        @if (!iconClass) {
          <iris-folder-svg
            width="52"
            height="46"
            [color]="'#a1a6ab'"
            [hasChildren]="hasChildren"
          ></iris-folder-svg>
        }

        <i [hidden]="!iconClass" class="fas text-secondary-light" [ngClass]="iconClass"></i>
      </p>
      <h3 class="mb-2 empty-content-title">{{ label | translate }}</h3>
      <p class="m-0 empty-content-text">{{ message | translate }}</p>
    </div>
  </div>
</div>
